// Woodmoor and Woodcrest are excluded because their shingles have rendering issues in this visualizer.
const EXCLUDED_SHINGLE_UIDS = ['woodmoor', 'woodcrest'];

export const shingleLineHasDayNightVisualizer = shingleUid => !EXCLUDED_SHINGLE_UIDS.includes(shingleUid);
